import axios from "axios";
import { message } from "antd";
const request = axios.create({
  timeout: 5000,
});

// 添加请求拦截器
request.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    // let status = response.data.status;
    // if (status === 200) {
    //   message.success(response.data.message);
    // } else {
    //   message.error(response.data.message);
    // }
    return response;
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    message.error("未知错误");
    return Promise.reject(error);
  }
);

type API = {
  qq: Function;
  phone: Function;
  LolQQ: Function;
  LolName: Function;
  wbid: Function;
  wbphone: Function;
};

const api: API = {
  qq: (data: string) => request.get("https://zy.xywlapi.cc/qqapi?qq=" + data),
  phone: (data: string) =>
    request.get("https://zy.xywlapi.cc/qqphone?phone=" + data),
  LolQQ: (data: string) =>
    request.get("https://zy.xywlapi.cc/qqlol?qq=" + data),
  LolName: (data: string) =>
    request.get("https://zy.xywlapi.cc/lolname?name=" + data),
  wbid: (data: string) =>
    request.get("https://zy.xywlapi.cc/wbphone?phone=" + data),
  wbphone: (data: string) =>
    request.get("https://zy.xywlapi.cc/wbapi?id=" + data),
};

export default api;
